import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import auth from './auth/';
import ui from './ui/';


export default history => // eslint-disable-line 
  combineReducers({
    auth,
    ui,
    router: connectRouter(history),
  });
